export const ReportTypes = [
    {
        id: 1,
        type: "rkeeper",
        name: "Rkeeper",
    },
    {
        id: 2,
        type: "iiko",
        name: "iiko",
    },
    {
        id: 3,
        type: "xlsx",
        name: "Xlsx",
    },
    {
        id: 4,
        type: "xlsx",
        name: "Quik Resto",
    }
];
